import React from 'react';
import styled from 'styled-components';

import {
  Building1,
  Building2,
  Building3,
  Building4,
  BuildingsContainer,
  Road,
  RoadLine,
  SVGAnimationContainer,
  Truck,
  TruckContainer,
  TruckSvgContainer,
  TruckWheel
} from './styles';
import './styles.scss';
import logo from '../../../../assets/images/common/PakEnergy_Horiz_LockupsT_Transportation.png';
import CloudComponent from './Clouds';
import LoaderAppMin from './LoaderAppMin';

const SpinnerContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: ${process.env.REACT_APP_DS === 'DEPLOY' ? '#FFF' : '#23459d'};
  overflow: hidden;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 100px;
  z-index: 90000;
`;

const LoaderApp = () => {
  return process.env.REACT_APP_DS !== 'DEPLOY' ? (
    <SpinnerContainer>
      <LogoContainer className="cloud">
        <img src={logo} alt="PakEnergy" width="250px" />
      </LogoContainer>
      <>
        <div className="content">
          <div className="content__container">
            <p className="content__container__text">Loading</p>
            <ul className="content__container__list">
              <li className="content__container__list__item"> Application !</li>
              <li className="content__container__list__item"> Commodities !</li>
              <li className="content__container__list__item"> Drivers !</li>
              <li className="content__container__list__item"> Pickups !</li>
            </ul>
          </div>
        </div>
        <BuildingsContainer>
          <Building1 />
          <Building2 />
          <Building3 />
          <Building4 />
        </BuildingsContainer>
        <SVGAnimationContainer>
          <CloudComponent />
          <TruckContainer>
            <TruckSvgContainer>
              <Truck width={200} />
              <TruckWheel width={22} bottom={9.3} left={32.1} />
              <TruckWheel width={22} bottom={9.2} left={57.5} />
              <TruckWheel width={22} bottom={9.2} left={101.4} />
              <TruckWheel width={22} bottom={9.2} left={162.4} />
            </TruckSvgContainer>
          </TruckContainer>
          <Road>
            <RoadLine />
          </Road>
        </SVGAnimationContainer>
      </>
    </SpinnerContainer>
  ) : (
    <LoaderAppMin />
  );
};

export default LoaderApp;
